export default function prepopulateCurrentDateAction() {
	const now = new Date();
	// Create a new date at local midnight
	const localMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const prepopValue = localMidnight.toISOString();
	return prepopValue;
}
